import { InputHasErrorProp, InputSizeVariantProp } from './Input'
import { getBaseInputStyles } from './helpers/get-base-input-styles'
import { cn } from '@lib/cn'
import { FC, InputHTMLAttributes } from 'react'

export type SelectProps = InputHasErrorProp &
  InputSizeVariantProp &
  InputHTMLAttributes<HTMLSelectElement> & {
    className?: string
  }

export const Select: FC<SelectProps> = ({ variant = 'regular', hasError, className, ...rest }) => {
  const baseInputStyle = getBaseInputStyles(hasError)
  const hasValue = !!rest.value
  return (
    <select
      className={cn(
        baseInputStyle,
        'rolex-select-labels-transform cursor-pointer appearance-none pb-0 pt-2',
        hasValue && 'rolex-select-labels-transform-has-value',
        className,
      )}
      style={{
        backgroundSize: '2rem',
        background:
          "url(\"data:image/svg+xml,%3Csvg width='8' height='5' viewBox='0 0 8 5' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 0H0L4 5L8 0Z' fill='%23818181' /%3E%3C/svg%3E%0A\") no-repeat 100% 55%",
      }}
      {...rest}
    />
  )
}
